export default __webpack_public_path__ + "static/media/gallery_03.8dc84af9.jpg";